import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material/styles';

export const footerNavbarSX: SxProps<Theme> = {
	backgroundColor:'navbar.primary',
    height:globalBreak({mobile:'auto',desktop:100}),
    color: '#000'
};

export const footerLinksContainerSX: SxProps<Theme> = {
    borderBottom:'1px solid #dfdfdf'
};